export const TRY_LOGIN = 'TRY_LOGIN';

export const TRY_LOGOUT = 'TRY_LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const TRY_VERIFY_AUTH_CODE = 'TRY_VERIFY_AUTH_CODE';

export interface UserLoginRequest {
    email: string;
    password: string;
    hubSpotUserToken: string;
    stapeId?: string; // for tracking
}

export interface LoginWithSSORequest {
    redirectPath: string;
    hubSpotUserToken: string;
    stapeId?: string;
    email: string;
}

export interface Verify2FACodeRequest {
    userId: string;
    code: string;
}

export interface TryLoginAction {
    type: typeof TRY_LOGIN;
    payload: UserLoginRequest;
}

export interface TryLogoutAction {
    type: typeof TRY_LOGOUT;
}

export interface LogoutSuccessAction {
    type: typeof LOGOUT_SUCCESS;
    payload: void;
}

export interface TryVerifyAuthCodeAction {
    type: typeof TRY_VERIFY_AUTH_CODE;
    payload: Verify2FACodeRequest;
}

// Action Creators

export const tryLogin: (request: UserLoginRequest) => TryLoginAction = (request) => {
    return {
        type: TRY_LOGIN,
        payload: request,
    };
};

export const tryLogout: () => TryLogoutAction = () => {
    return {
        type: TRY_LOGOUT,
    };
};

export const logoutSuccess: () => LogoutSuccessAction = () => {
    return {
        type: LOGOUT_SUCCESS,
        payload: null,
    };
};

export const tryVerifyAuthCode: (request: Verify2FACodeRequest) => TryVerifyAuthCodeAction = (request) => {
    return {
        type: TRY_VERIFY_AUTH_CODE,
        payload: request,
    };
};
